import {useContext} from "react";
import {Context} from "./context";
import {useLocation} from "react-router-dom";
import {Urls} from "component/const/Urls";

export function Searching() {
    const {search, setSearch} = useContext(Context)
    const urls = [Urls.profile, Urls.ask, Urls.alert, Urls.logout]
    const {pathname} = useLocation();
    return (
        !urls.includes('/'+pathname.split('/').pop()) && <div className={'row'} style={{marginBottom:20}}>
            <select className={`inputBorder`} style={{flexGrow: 0}} >
                <option value={'전체'}>전체</option>
            </select>
            <input className={` inputBorder inputTextAreaMargin`} value={search}
                onChange={event => setSearch(event.target.value)}
            />
        </div>
    )
}